var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, FieldValidation, RadioGroup, } from '#design-system';
import { useField, useFieldDependency, } from '#form-builder';
import { toLabelled } from '#services';
const DEFAULT_VALIDATION_RULES = [];
export const RadioGroupField = ({ 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus, className, clientErrorMessage, 'data-testid': testId, initialValue, items, label, name, radioGroupItemsPerColumn, required, rules = DEFAULT_VALIDATION_RULES, ...props }) => {
    _react_refresh_temp_2();
    const builtInitialValue = useMemo(() => {
        if (typeof initialValue === 'function') {
            return initialValue({});
        }
        else {
            return initialValue ?? '';
        }
    }, [initialValue]);
    const { 
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- dependencyValue is any on purpose
    dependencyValue, errors, fieldRef, isFocused, isTouched, onBlurHandler, onChangeHandler, onFocusHandler, value, } = useField({
        autoFocus,
        ...props,
        name,
        initialValue: builtInitialValue,
    });
    const dependantData = useFieldDependency({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- dependencyValue is any on purpose
        dependencyValue,
        required,
    });
    const hasErrors = Boolean(errors.length) && isTouched;
    const fieldValidationId = `field-validation-${props.id}`;
    return (_jsxs(Box, { className: className, gap: "xs", isFullWidth: true, orientation: "vertical", children: [_jsx(RadioGroup, { "aria-describedby": fieldValidationId, "data-testid": testId, items: items, ref: fieldRef, ...toLabelled(label, ariaLabel, ariaLabelledBy), name: name, onBlur: onBlurHandler, onChange: (val) => {
                    onChangeHandler(val);
                }, onFocus: onFocusHandler, radioGroupItemsPerColumn: radioGroupItemsPerColumn, required: dependantData.required, selectedValue: value, ...(hasErrors && {
                    'aria-errormessage': fieldValidationId,
                }), ...(hasErrors && { 'aria-invalid': true }) }), _jsx(FieldValidation, { clientErrorMessage: clientErrorMessage, "data-testid": testId, errors: errors, id: fieldValidationId, isActive: isTouched, isFocused: isFocused, rules: rules })] }));
};
_react_refresh_temp_1 = RadioGroupField;
$RefreshReg$(_react_refresh_temp_1, "RadioGroupField");
_react_refresh_temp_2(RadioGroupField, "7LnEM1IR9rsqY4ujvpRYmMDdRBE=", false, () => [useField, useFieldDependency]);
